<template>
    <div class="vue2orgTreeCom" align="center">
        <vue2OrgTree 
            :data="tree"
            :horizontal="horizontal"
            :collapsable="collapsable"
            :label-class-name="labelClassName"
            @on-expand="onExpand"
            @on-node-click="onNodeClick"
        >
        </vue2OrgTree>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    import vue2OrgTree from 'vue2-org-tree';
    export default {
        components: {
            vue2OrgTree
        },
        data () {
            return {
                tree: {
                    id: 0,
                    label: 'xxx科技有限公司',
                    children: [
                        {
                            id: 2,
                            label: '产品研发部',
                            style: { color: '#fff', backgroundColor: '#108ffe' },
                            children: [
                                {
                                    id: 5,
                                    label: '研发-前端'
                                },
                                {
                                    id: 6,
                                    label: '研发-后端'
                                },
                                {
                                    id: 9,
                                    label: 'UI设计'
                                },
                                {
                                    id: 10,
                                    label: '产品经理'
                                }
                            ]
                        },
                        {
                            id: 3,
                            label: '销售部',
                            children: [
                                {
                                    id: 7,
                                    label: '销售一部'
                                },
                                {
                                    id: 8,
                                    label: '销售二部'
                                }
                            ]
                        },
                        {
                            id: 4,
                            label: '财务部'
                        },
                        {
                            id: 9,
                            label: 'HR人事'
                        }
                    ]
                },
                labelClassName: 'label-def'
            };
        },
        props: {
            horizontal: {// true:横排,false:竖排
                type: Boolean,
                default: false
            },
            collapsable: {// 是否带节点展开功能
                type: Boolean,
                default: true
            },
            expandAll: {// 是否展开所有节点
                type: Boolean,
                default: false
            },
            treeData: {
                type: Object,
                default: {}
            }
        },
        created () {
            // 初始化数据
            if (this.treeData && Array.isArray(this.treeData)) {
                let _tree = {
                    id: -1,
                    label: '根节点',
                    children: cloneDeep(this.treeData)
                };
                this.tree = _tree;
            } else {
                this.tree = cloneDeep(this.treeData);
            }
            // 是否展开所有节点
            this.toggleExpand(this.tree, this.expandAll);
        },
        methods: {
            onExpand (e, data) {
                e.stopPropagation();
                if ('expand' in data) {
                    data.expand = !data.expand;
                    if (!data.expand && data.children) {
                        this.collapse(data.children);
                    }
                } else {
                    this.$set(data, 'expand', true);
                }
            },
            onNodeClick (e, data) {
                this.$message(data.label);
            },
            collapse (list) {
                list.forEach(child => {
                    if (child.expand) {
                        child.expand = false;
                    }
                    child.children && this.collapse(child.children);
                });
            },
            expandChange () {
                this.toggleExpand(this.data, this.expandAll);
            },
            toggleExpand (data, val) {
                if (Array.isArray(data)) {
                    data.forEach(item => {
                        this.$set(item, 'expand', val);
                        if (item.children) {
                            this.toggleExpand(item.children, val);
                        }
                    });
                } else {
                    this.$set(data, 'expand', val);
                    if (data.children) {
                        this.toggleExpand(data.children, val);
                    }
                }
            }
        }
};
</script>

<style lang="less">
@import '~assets/styles/org.css';
.vue2orgTreeCom{
    .label-def{
        background: #ffffff;
        color: #5e6d82;
        
    }
}

</style>


// WEBPACK FOOTER //
// src/components/OrgTree/OrgTree.vue